function assetPreviewTagsEmptyMode () {
  return {
    restrict: 'E',
    data: {},
    templateUrl: '/core/directives/asset-preview-tags/components/asset-preview-tags-empty-mode.html?$$REVISION$$'
  }
}
export { assetPreviewTagsEmptyMode }
